import React from 'react';

// Buttons (handoff_app_design/README.md §4.4). One component, three variants — no screen styles
// its own button.
//
//   <Button>שמור</Button>                                  primary
//   <Button variant="secondary">ביטול</Button>
//   <Button variant="tinted" tone="positive" icon={<ThumbsUp/>}>הרגיש טוב</Button>
//
// Props: variant ('primary' | 'secondary' | 'tinted'), tone (for 'tinted': 'positive' | 'quality'
// | 'accent'), icon (leading), trailingIcon, fullWidth (default true), as/href for a link button.
const BASE = 'inline-flex items-center justify-center gap-2 rounded-control font-extrabold ' +
  'active:scale-[.98] transition-transform disabled:opacity-50 disabled:pointer-events-none ' +
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent focus-visible:outline-offset-2';

const VARIANTS = {
  primary: 'h-12 text-[15px] btn-primary',
  secondary: 'h-[46px] text-[15px] bg-transparent border border-border text-text',
};

const TINT_TONE = {
  positive: 'bg-positive-soft text-positive border border-positive/35',
  quality: 'bg-quality-soft text-quality border border-quality/35',
  accent: 'bg-accent-soft text-accent border border-accent/35',
};

export default function Button({
  variant = 'primary',
  tone = 'accent',
  icon,
  trailingIcon,
  fullWidth = true,
  as: As = 'button',
  className = '',
  children,
  ...rest
}) {
  const variantClass = variant === 'tinted'
    ? `h-[46px] text-[14px] font-bold ${TINT_TONE[tone] || TINT_TONE.accent}`
    : (VARIANTS[variant] || VARIANTS.primary);
  return (
    <As
      type={As === 'button' ? (rest.type || 'button') : undefined}
      className={`${BASE} ${variantClass} ${fullWidth ? 'w-full' : ''} ${className}`}
      {...rest}
    >
      {icon}
      {children}
      {trailingIcon}
    </As>
  );
}
